import { render, staticRenderFns } from "./groupConfig.vue?vue&type=template&id=5cac48df"
import script from "./groupConfig.vue?vue&type=script&lang=js"
export * from "./groupConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports